module.exports = __webpack_public_path__ + "08016585a08e228abeca2923c83e1a56.png";